var map = {
	"./100.jpg": 999,
	"./100.png": 9332,
	"./ABV_Logo.jpg": 1140,
	"./Elixir.jpg": 5242,
	"./Elixir.png": 9151,
	"./Logo.jpg": 9414,
	"./Logo1.jpg": 4418,
	"./Portfolio.png": 5159,
	"./Profile.jpg": 5754,
	"./Ryan_Logo.png": 1202,
	"./Scheduler.png": 8620,
	"./Securex.png": 9390,
	"./b.png": 9076,
	"./buld.jpg": 8543,
	"./codeInLogo.png": 7935,
	"./codeuino.jpg": 8394,
	"./coursera_logo.png": 1877,
	"./cra.png": 3634,
	"./dal.png": 6288,
	"./deeplearning_ai_logo.png": 2862,
	"./googleAssistant.jpg": 700,
	"./google_logo.png": 5927,
	"./hrishi2.png": 2223,
	"./ino.png": 6380,
	"./intel_logo.jpg": 3026,
	"./quicko.jpg": 917,
	"./sal.png": 5693,
	"./stanford_logo.png": 7137,
	"./vidya_Logo (1).png": 3917,
	"./vidya_Logo.png": 3857,
	"./vjt.png": 7115,
	"./wrighter.jpg": 7039
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1106;